import styled from 'styled-components'
import { Button, Flex, Input, getPaletteColor } from 'pcln-design-system'

export const StyledMenuButton = styled(Button)`
  > ${Flex} {
    justify-content: left;
  }
  position: relative;
  height: 56px;
  padding: 0px;
  &:focus-visible {
    outline: solid 3px ${getPaletteColor('primary.base')};
  }
`

export const StyledInput = styled(Input)`
  position: absolute;
  left: 0;
  height: 56px;
  /* TODO: Addresses a bug in DS v5.13.0. Should be removed in future when DS is fixed */
  &:read-only {
    position: absolute !important;
    background-color: transparent !important;
    color: ${getPaletteColor('text.base')} !important;
    cursor: pointer !important;
  }
`
